import React, { useState } from 'react'
import { Form, Spinner } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { Button } from 'reactstrap'
import { message } from 'antd'

import { storeWarehouse } from '../services'
import { handleError } from '../../../helpers'

export default function NewWarehouseForm({ reload }) {
	const { handleSubmit, register, formState: { errors }, reset } = useForm({})
	const [loading, setLoading] = useState(false)

	const onSubmit = values => {
		setLoading(true)
		storeWarehouse(values)
			.then(res => {
				message.success(res.data.message)
				setLoading(false)
				reset()
				reload()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Form onSubmit={handleSubmit(onSubmit)}>
				<Form.Group className='form-group'>
					<Form.Label>Código <span className='text-primary'>*</span></Form.Label>
					<Form.Control
						{...register('sku', { required:true })}
						placeholder='Escriba aquí...'
					/>
					{ errors.sku && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
				</Form.Group>
				<Form.Group className='form-group'>
					<Form.Label>Nombre de Bodega <span className='text-primary'>*</span></Form.Label>
					<Form.Control
						{...register('name', { required:true })}
						placeholder='Escriba aquí...'
					/>
					{ errors.name && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
				</Form.Group>
				<Form.Group className='form-group'>
					<Form.Label>Dirección <span className='text-primary'>*</span></Form.Label>
					<Form.Control 
						{...register('address', { required: true })}
						placeholder='Escriba aquí...'
					/>
					{ errors.address && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text>}
				</Form.Group>
				<Button color='primary' type="submit" disabled={loading}>
					{ loading && <Spinner animation='border' size="sm" className='mr-5' /> }
					Crear Nueva Bodega
				</Button>
			</Form>
		</React.Fragment>
	)
}